import React from 'react';
import { residentialCommercial as data, contact } from '../../content/site';
import { ArrowRight, Mail } from '../Common/Icons';

const AboutResidentialCommercial = () => (
  <section className="section">
    <div className="container">
      <div className="detail__grid">
        <div className="detail__media reveal">
          <img
            src={data.image}
            alt="LIDA Engineering technician installing overhead fittings on a residential fit-out"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="detail__body reveal" style={{ '--reveal-delay': '100ms' }}>
          <p className="eyebrow">Overview</p>
          <p className="detail__lead">{data.lead}</p>

          {data.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          <div className="detail__cta">
            <a href={`mailto:${contact.email}`} className="btn">
              Request a Quote
              <ArrowRight />
            </a>
            <a href="#contact" className="btn btn--outline">
              <Mail />
              Contact us
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutResidentialCommercial;
